import React from 'react';
import { Importer, ImporterField } from 'app/components/general/CsvImporter';
import _, { forEach } from 'lodash';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
import history from 'app/routes/history';
import SectionGroup from 'app/components/general/SectionGroup';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import Button from 'app/components/general/Button';
import { Form } from 'reactstrap';
import Dropzone from 'react-dropzone';
import UploadIcon from 'app/images/icons/upload.svg';
// import 'react-csv-importer/dist/index.css';

interface IUploadFileProps {
  appReady: boolean;
  actions: any;
  match: any;
  users: any;
  errors: any;
  changeFileContent: any;
}

interface IUploadFileState {
  dragStatus: any;
  competition: any;
}
export default class UploadFile extends React.Component<
IUploadFileProps,
IUploadFileState
> {
  static defaultProps: IUploadFileProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    users: {},
    errors: undefined,
    changeFileContent: undefined,
  };

  state: IUploadFileState = {
    dragStatus: null,
    competition: undefined,

  };

  handleFileUpload = (acceptedFiles) => {
    const reader = new FileReader();

    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      this.props.changeFileContent(reader.result);
    };
    acceptedFiles.forEach((file) => reader.readAsText(file));
  };

  checkIfAllMapped = (): boolean => true

  handleSubmit = (fileContent, fileMapping) => {
    if (this.checkIfAllMapped()) {
      const payload = {
        fileMapping,
        bulkImportType: 'manager-teams',
        fileSource: 'body',
        fileType: 'csv',
        fileContent,
        staticData: {
          'user-id': this.props.users.currentUserId,
        },
      };
      // console.log(payload);
      this.props.actions.createBulkImport(payload, (dataImportId) => {
        history.push(
          {
            pathname: `/import/team-members/review/${dataImportId}`,
            state: { modal: this.props.match.isModal },
          },
        );
      });
    }
  };

  render(): React.ReactNode {
    const getDropStatus = () => {
      if (this.state.dragStatus === 'accepted') {
        return 'accept';
      }
      if (this.state.dragStatus === 'error') {
        return 'error';
      }
      return null;
    };
    return (
      <div>
        <SectionGroup
          title="Upload CSV file"
        >
          {/* <Form onSubmit={() => (
            history.push(
              {
                pathname: '/import/customers/map',
                state: { modal: this.props.match.isModal },
              },
            ))}
          > */}
          {/* <div className="row">
            <div className="col">
              <InputGroupBlock
                type="select"
                name="organisation"
                labelText="Competition"
                placeholder="Competition"
                aria-label="Competition"
                inputGroupClassName="no-margin-bottom"
                autoComplete="off"
                value={this.state.competition}
                options={
                  this.props.competitions.competitionsByIdInSelectFormat
                }
                onChange={this.handleCompetitionChange}
              />
            </div>
          </div> */}
          <div className="row">
            <div className="col">
              Importing a CSV allows you to add and update team members stored in Teammo. If a team member ID or email address in your CSV matches an existing team member in Teammo, they will be updated with the mapped values. Otherwise, a new team member will be created.
            </div>
          </div>
          <div className="row with-margin-top-10">
            <div className="col">
              <span className="d-block">Data fields that are able to be imported:</span>
              <ul>
                <li>Team Name (required)</li>
                <li>Team Season</li>
                <li>Team Member Name (required)</li>
                <li>Team Member Mobile (required)</li>
                <li>Team Member Email</li>
              </ul>
            </div>
          </div>
          <div className="row with-margin-top">
            <div className="col">
              <Importer
                assumeNoHeaders={false}
                restartable={false}
                onStart={({
                  file, preview, fields, columnFields,
                }) => {
                  // console.log(file);
                  // console.log(preview);
                  // console.log(fields);
                  // console.log(columnFields);
                  // console.log('submit');
                  const mapping = {};

                  _.each(preview.columns, (c) => {
                    const fieldName = columnFields[c.index];
                    mapping[fieldName] = c.header;
                  });
                  // console.log(mapping);
                  this.handleSubmit(preview.rawData, mapping);
                }}
                processChunk={async (rows, { startIndex }) => {
                  // for (row of rows) {
                  //   console.log(row);
                  //   // await myAppMethod(row);
                  // }
                  // console.log('process');
                }}
                onComplete={({
                  file, preview, fields, columnFields,
                }) => {
                  // console.log(file);
                  // console.log(preview);
                  // console.log(fields);
                  // console.log(columnFields);
                  // console.log('complete');
                }}
                onClose={({
                  file, preview, fields, columnFields,
                }) => {
                  // console.log('close');
                  history.push('/team-members');
                }}

              >
                <ImporterField name="team-member.full-name" label="Full Name" />
                <ImporterField name="team-member.email" label="Email" optional />
                <ImporterField name="team-member.mobile" label="Mobile" />
                <ImporterField name="team.name" label="Team" />
                <ImporterField name="team.season" label="Season" optional />
              </Importer>

              {/* <div
                className={classnames('row with-margin-top-10', {
                  'd-none': this.state.dragStatus !== 'accepted',
                })}
              >
                <div className="col btn-flex-group less-padding">
                  <div className="btn-flex-container">
                    <Button
                      className="btn-standard btn-1"
                      type="submit"
                    >
                      Map Fields
                    </Button>
                    <Button
                      onClick={() => history.goBack()}
                      className="btn-standard btn-2"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div> */}
            </div>

          </div>

          {/* </Form> */}
        </SectionGroup>
        {/* <SectionGroup
          title="Preview file"
          className="with-margin-top"
        >
          <div className="row">
            <div className="col">
              Fields you will need to map:
            </div>
          </div>
        </SectionGroup> */}
      </div>
    );
  }
}
